import React from 'react';
import HeroSlider from '../components/HeroSlider';
import AdvantagesSection from '../components/AdvantagesSection';
import PlansSection from '../components/PlansSection';
import AppSection from '../components/AppSection';
import SecuritySection from '../components/SecuritySection';
import { contactInfo } from '../mockData';

const Home = () => {
  return (
    <div>
      <HeroSlider />
      <AdvantagesSection />
      <PlansSection />
      
      {/* App Section */}
      <AppSection />

      {/* Streaming Section */}
      <section className="py-20 bg-gradient-to-br from-gray-900 to-gray-800 text-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div>
              <h2 className="text-4xl md:text-5xl font-bold mb-6">
                ASSISTA AS SUAS SÉRIES E FILMES
              </h2>
              <h3 className="text-3xl md:text-4xl font-bold text-orange-500">
                SEM INTERRUPÇÃO
              </h3>
            </div>
            <div className="rounded-2xl overflow-hidden shadow-2xl">
              <img
                src="https://images.unsplash.com/photo-1522869635100-9f4c5e86aa37?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Família assistindo streaming"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </section>

      {/* Business Section */}
      <section className="py-20 bg-white">
        <div className="container mx-auto px-4">
          <div className="grid grid-cols-1 lg:grid-cols-2 gap-12 items-center">
            <div className="rounded-2xl overflow-hidden shadow-2xl order-2 lg:order-1">
              <img
                src="https://images.unsplash.com/photo-1497366216548-37526070297c?crop=entropy&cs=srgb&fm=jpg&q=85"
                alt="Empresas"
                className="w-full h-full object-cover"
              />
            </div>
            <div className="order-1 lg:order-2">
              <h2 className="text-4xl md:text-5xl font-bold mb-6 text-gray-800">
                MELHORE O DESEMPENHO DA SUA EMPRESA
              </h2>
              <h3 className="text-3xl md:text-4xl font-bold text-orange-500 mb-8">
                CONHEÇA NOSSOS PLANOS EMPRESARIAIS
              </h3>
              <a
                href="/para-sua-empresa"
                className="inline-block bg-orange-500 text-white px-8 py-4 rounded-lg text-lg font-bold hover:bg-orange-600 transition-all hover:scale-105 shadow-lg"
              >
                Saiba mais
              </a>
            </div>
          </div>
        </div>
      </section>

      {/* Security Section - Moved to last */}
      <SecuritySection />
    </div>
  );
};

export default Home;
